import React from 'react';
import { Box } from '@mui/material';
import EditButton from './Buttons/EditButton';
import DownloadExcelModelButton from './Buttons/DownloadExcelModelButton';
import DownloadExcelButton from './Buttons/DownloadExcelButton';
import UploadExcelButton from './Buttons/UploadExcelButton';
import EditService from '../UI/EditService';

const Functions = {
  EditButton,
  DownloadExcelModelButton,
  UploadExcelButton,
  DownloadExcelButton,
  EditService,
};

export default function FunctionButtonGroup({
  dynamicStructure = { dbName: '', funcs: [], fields: [], text: '' },
  setIsUpdate = () => {},
  setSelectedVendor = () => {},
}) {
  const { dbName, funcs, fields, text } = dynamicStructure;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
      }}
    >
      {funcs.map((func, index) => {
        const Func = Functions[func.type];
        return (
          <Func
            key={index}
            {...{
              text,
              dbName,
              func,
              fields,
              setIsUpdate,
              setSelectedVendor,
            }}
          />
        );
      })}
    </Box>
  );
}
